import styles from "./KPICards.module.css";

interface KpiItem {
    id: string;
    title: string;
    value: number;
}

interface KpiItemList extends Array<KpiItem> {}

interface Props {
    kpis: KpiItemList;
}

const KPICard = ({ id, title, value }: KpiItem) => {
    return (
        <div className={`card col-2 ${styles.kpiCard}`}>
            <div className={styles.cardBody}>
                <div className={`fs-5 text-center ${styles.kpiTitle}`}>
                    {title}
                </div>
                <div
                    className={`text-center ${styles.kpiValue}`}
                >
                    {" "}
                    {value}
                </div>
            </div>
        </div>
    );
};

function KPICards({ kpis }: Props) {
    return (
        <>
            {/* <h2 className="text-center">KPI</h2> */}
            <div className="row d-flex justify-content-center align-items-center">
                {kpis.map((kpi, index) => (
                    <KPICard
                        key={index}
                        id={kpi.id}
                        title={kpi.title}
                        value={kpi.value}
                    ></KPICard>
                ))}
            </div>
        </>
    );
}
export default KPICards;
